import React, { Component } from 'react';
import { Link } from "react-router-dom";
import  createHistory  from 'history/createBrowserHistory';

class ApprovalBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <p>
                In case you are a Lenovo customer, please use the <a href="/">Dispute Portal for Customers.</a>
                {/*In case you are a Lenovo customer, please use the <Link to={{pathname: '/',state:'/'}}>Dispute Portal for Customers.</Link>*/}
            </p>
        </div>
    }
}

export default ApprovalBar;